// Press-release show more trigger

function activateScrollLinks(scrollLinks, offset = 50) {

    if (typeof (scrollLinks) !== 'undefined' && scrollLinks !== null) {

        for (var i = 0; i < scrollLinks.length; i++) {

            scrollLinks[i].addEventListener('click', function (e) {

                e.preventDefault();

                var href = this.getAttribute('href'),
                    element = document.querySelector(href),
                    offsetTop = 0;

                if (history.pushState) {
                    offsetTop = element.offsetTop - offset;
                } else {
                    offsetTop = element.offsetTop;
                }

                const onScroll = function () {
                    window.removeEventListener('scroll', onScroll);
                    setTimeout(function() {
                        if (history.pushState) {
                            history.pushState(null, null, href);
                        }
                        else {
                            location.hash = href;
                        }
                    }, 500);
                }

                window.addEventListener('scroll', onScroll);

                window.scrollTo({
                    top: offsetTop,
                    behavior: 'smooth',
                });

            });

        }
    }

}

function scrollTo() {

    activateScrollLinks(document.querySelectorAll('.scroll-link'));

    activateScrollLinks(document.querySelectorAll('.learn-more-link'));

    activateScrollLinks(document.querySelectorAll('.toc-link'));

    activateScrollLinks(
        document.querySelectorAll('.category-icon-link'),
        (window.screen.availWidth < 768) ? 265 : 50
    );

}

export default function init() {
    scrollTo();
}
